import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';


const Breadcrumb = ({ items }) => {
  const location = useLocation();
  const isSpecificPage = /^\/chat\/[a-f0-9]{64}\/\d+\/\d+\/+$/.test(location.pathname + location.search);

  return (
    <nav aria-label="breadcrumb" style={{ position: "relative",  zIndex: 12}}>
      <ul style={{ display: "flex", listStyle: "none", margin: "0 10px", position: isSpecificPage ? "fixed" : "relative"}}>
        {items.map((item, index) => (
          <li key={index}>
            {index < items.length - 1 ? (
              <>
                <Link to={item.path} style={{color:"rgba(120, 123, 120, 1)"}}>
                  {item.label}
                </Link>
                <span style={{color:"rgba(120, 123, 120, 1)", margin: "0 3px"}}>/</span>
              </>
            ) : (
              <span style={{ margin: "0 3px", color:"rgba(120, 123, 120, 1)"}}>{item.label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
